module.exports = __webpack_public_path__ + "static/actions@2x-c1fc3630e34e4a156cd4bbf7e940ad5e.png";